/**
 * useMemberQueries — 회원 도메인 react-query hooks.
 */
import { useQuery } from "@tanstack/react-query";
import { fetchMe, type Me } from "../api/member";

export const ME_KEY = ["member", "me"] as const;

/**
 * GET /members/me — 프로필 전체 (introduction / profileImageUrl 포함).
 * 로그인 응답(TokenResponse)에는 nickname 까지만 있으므로, 프로필을 그리는 화면은
 * 이 쿼리로 보강해야 한다 (MyPage 등).
 */
export function useMeQuery(options?: { enabled?: boolean }) {
  return useQuery<Me | null>({
    queryKey: ME_KEY,
    queryFn: () => fetchMe(),
    enabled: options?.enabled ?? true,
  });
}
